export default __webpack_public_path__ + "static/media/404.70f734cb.svg";